import { render, staticRenderFns } from "./properties-block-table-row.vue?vue&type=template&id=334cdcae&scoped=true"
import script from "./properties-block-table-row.vue?vue&type=script&lang=js"
export * from "./properties-block-table-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334cdcae",
  null
  
)

export default component.exports